import './Reviews.css';
import SnapScrapTrustpilot from './SnapScrapTrustpilot';

const REVIEWS = [
  {
    title: 'Excellent Service',
    body: 'Booked same-day scrap collection and the team arrived on time, cleared everything carefully, and left the yard tidy. Could not recommend more.',
    name: 'Sarah M.',
    when: '9 Days ago',
  },
  {
    title: 'Highly Recommended',
    body: 'Professional from start to finish. Fair price, no hidden charges, and they recycled almost everything. Will definitely use SnapScrap again.',
    name: 'James T.',
    when: '2 Weeks ago',
  },
  {
    title: 'Brilliant',
    body: 'Had a full site scrap clear-out done in one visit. Friendly crew, quick turnaround, and the digital waste notes gave me total peace of mind.',
    name: 'Priya K.',
    when: '5 Days ago',
  },
  {
    title: 'Fast & Reliable',
    body: 'Emergency white goods and radiator removal sorted within hours. Communication was clear and the service felt properly licensed and legit.',
    name: 'Daniel R.',
    when: '3 Weeks ago',
  },
  {
    title: 'Great Experience',
    body: 'Copper and steel collection was easy to book online. The team were respectful, efficient, and tidied up after themselves.',
    name: 'Emily W.',
    when: '12 Days ago',
  },
  {
    title: 'Top Quality',
    body: 'Used them for commercial scrap clearance. Transparent pricing, secure payment, and everything was collected exactly as quoted.',
    name: 'Oliver H.',
    when: '1 Month ago',
  },
];

function GoogleLogo() {
  return (
    <span className="google-logo" aria-label="Google">
      <span style={{ color: '#4285F4' }}>G</span>
      <span style={{ color: '#EA4335' }}>o</span>
      <span style={{ color: '#FBBC05' }}>o</span>
      <span style={{ color: '#4285F4' }}>g</span>
      <span style={{ color: '#34A853' }}>l</span>
      <span style={{ color: '#EA4335' }}>e</span>
    </span>
  );
}

function Stars() {
  return (
    <div className="review-stars" aria-label="5 stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} viewBox="0 0 20 20" aria-hidden="true">
          <path
            fill="#FABB05"
            d="M10 1.5l2.5 5.1 5.6.8-4 3.9.9 5.6L10 14.3 5 16.9l.9-5.6-4-3.9 5.6-.8L10 1.5z"
          />
        </svg>
      ))}
    </div>
  );
}

function ReviewCard({ review }) {
  return (
    <article className="review-card">
      <div className="review-card-inner">
        <div className="review-card-top">
          <GoogleLogo />
          <Stars />
        </div>
        <h3>{review.title}</h3>
        <p>{review.body}</p>
        <strong>{review.name}</strong>
        <span className="review-when">{review.when}</span>
      </div>
    </article>
  );
}

export default function Reviews() {
  const loop = [...REVIEWS, ...REVIEWS];

  return (
    <section className="reviews" aria-label="Reviews">
      <div className="reviews-marquee">
        <div className="reviews-track">
          {loop.map((review, index) => (
            <ReviewCard key={`${review.name}-${index}`} review={review} />
          ))}
        </div>
      </div>
      <SnapScrapTrustpilot />
    </section>
  );
}
